import { AuditLogs } from "@/components/audit-logs/audit-logs-overview.tsx";
import { PlanGate } from "@/components/plan-gate.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

// Deliberately outside /settings/org: audit logs are plan-gated but not
// admin-gated, matching the previous /dashboard/audit-logs behaviour.
export const Route = createFileRoute("/_authenticated/settings/audit-logs")({
	component: RouteComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.audit_logs_title()) }],
	}),
});

function RouteComponent() {
	return (
		<PlanGate
			requiredPlan="starter"
			featureName={m.plan_gate_feature_audit_logs()}
			description={m.plan_gate_desc_audit_logs()}
			benefits={[
				m.plan_gate_benefit_audit_history(),
				m.plan_gate_benefit_audit_retention(),
				m.plan_gate_benefit_audit_filter(),
			]}
		>
			<AuditLogs />
		</PlanGate>
	);
}
